import context from '../config/context'

const {
  branding: { assets },
  brandAssetsURL,
  talkdeskIdAssetsURL
} = context

const talkdeskAssetsURL = assets['base-url']
const logo = assets.logos.regular.svg

export const TALKDESK_LOGO = `${talkdeskAssetsURL}${logo}`
export const SECURITY_KEY = `${talkdeskIdAssetsURL}/mfa/securitykey.svg`
export const SECURITY_KEY_ANIMATION = `${talkdeskIdAssetsURL}/mfa/securitykey-animation.svg`
export const GOOGLE_PLAY_BADGE = `${brandAssetsURL}/brands/google/googleplay_badge.svg`
export const APPLE_STORE_BADGE = `${brandAssetsURL}/brands/apple/appstore_badge.svg`
